import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router-dom";
import { faForward } from "@fortawesome/free-solid-svg-icons";

const NextButton = () => {
  const { contestId, id } = useParams();
  const navigate = useNavigate();
  const pageType = window.location.pathname.split("/")[1];

  const nextPage = () => {
    for (let i = 50; i >= 0; i--) {
      window.clearTimeout(i);
    }
    if (pageType === "round") {
      switch (parseInt(id)) {
        case 1: // SongPage
          navigate(`/song/${parseInt(id) + 2}/${contestId}`);
          break;
        case 2: // SongPage
          navigate(`/song/${parseInt(id) + 3}/${contestId}`);
          break;
        case 3: // SongPage
          navigate(`/song/${parseInt(id) + 4}/${contestId}`);
          break;
        case 4: // ClosingPage
          navigate(`/final/${contestId}`);
          break;
        default:
      }
    } else if (pageType === "song") {
      switch (parseInt(id)) {
        case 1: // SongPage
        case 3:
        case 5:
        case 7:
          navigate(`/song/${parseInt(id) + 1}/${contestId}`);
          break;
        case 2: // VotePage
          navigate(`/round/${parseInt(id) - 1}/${contestId}`);
          break;
        case 4: // VotePage
          navigate(`/round/${parseInt(id) - 2}/${contestId}`);
          break;
        case 6: // VotePage
          navigate(`/round/${parseInt(id) - 3}/${contestId}`);
          break;
        case 8: // VotePage
          navigate(`/round/${parseInt(id) - 4}/${contestId}`);
          break;
        default:
      }
    }
  };
  return (
    <button className="skip-btn" onClick={nextPage}>
      Next Track  &nbsp;&nbsp;
      <FontAwesomeIcon icon={faForward} />
    </button>
  );
};

export default NextButton;
